import {Form as AntForm} from 'antd';
import React, {useEffect} from 'react';

import Form from '../../../../../components/Form/Form';
import MobileModalForm from '../../../../../components/Form/MobileModalForm';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import * as modalTypes from '../../../../../consts/modals/modalTypes';
import useIsMobileViewport from '../../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import helpers from '../../../../../utils/helpers';
import addUlcModalService from './addUlcModalService';

const AddUlcModal = (props) => {
    const {onOk, onCancel, modalType, initialData} = props;
    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const strings = getLocalizedStrings();
    const usesMobileUlcLayout = [modalTypes.SERVICES_ADD_ULC, modalTypes.SERVICES_EDIT_ULC].includes(modalType);

    const modalData = addUlcModalService.getAddUlcModalContent(modalType, initialData);

    const {formContent, title, submitButton, cancelButton, initialValues, buildingAddress} = modalData || {};

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            helpers.runFunction(onOk, values);
        } catch (error) {
            log.error(`AddUlcModal - validate failed: ${error}`);
        }
    };

    useEffect(() => {
        return () => {
            form.resetFields();
        };
    }, []);

    useEffect(() => {
        if (!usesMobileUlcLayout) return undefined;

        document.body.classList.add('ulc-edit-modal-open');

        return () => document.body.classList.remove('ulc-edit-modal-open');
    }, [usesMobileUlcLayout]);

    const handleChange = () => {};

    if (isMobile) {
        return (
            <MobileModalForm
                form={form}
                formName='ulc-settings'
                title={
                    <>
                        {title}
                        {buildingAddress && (
                            <span className='mt-1 block text-12 font-normal leading-18 text-santa'>
                                {buildingAddress}
                            </span>
                        )}
                    </>
                }
                closeLabel={strings[localizationKeys.SERVICES_MOBILE_CLOSE]}
                onCancel={onCancel}
                formFields={formContent}
                initialValues={initialValues}
                onFinish={onFinish}
                submitButton={submitButton}
                cancelButton={cancelButton}
                handleChange={handleChange}
            />
        );
    }

    return (
        <Form
            closeModal={onCancel}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formContent}
            cancelButton={cancelButton}
            formInstance={form}
            initialValues={initialValues}
            handleChange={handleChange}
            formClassName='ulc-edit-form'
            containerClassName='ulc-edit-form-content'
            buttonsClassName='ulc-edit-form-actions'
        />
    );
};

export default React.memo(AddUlcModal);
